import {
    AixAction,
    ErrorWrapper,
    IfgGatewayIntegrationFile,
    OrderApprovalConfig,
    OrderMarkNeedsClarificationRequest,
    OrderQueueOptions,
    OrderRecipientChange,
    type
} from '@trade-platform/ui-shared';

export class OrderAdminActionTypes {
    static readonly ORDER_NIGO_TO_NEEDS_CLARIFICATION = type(
        '[OrderAdmin] Order Nigo To Needs Clarification'
    );
    static readonly ORDER_NIGO_TO_NEEDS_CLARIFICATION_SUCCESS = type(
        '[OrderAdmin] Order Nigo To Needs Clarification Success'
    );
    static readonly ORDER_NIGO_TO_NEEDS_CLARIFICATION_FAILURE = type(
        '[OrderAdmin] Order Nigo To Needs Clarification Failure'
    );

    static readonly ORDER_TO_WETSIGN = type('[OrderAdmin] Order ESign To Wetsign');
    static readonly ORDER_TO_WETSIGN_SUCCESS = type('[OrderAdmin] Order ESign To Wetsign Success');
    static readonly ORDER_TO_WETSIGN_FAILURE = type('[OrderAdmin] Order ESign To Wetsign Failure');

    static readonly ORDER_MARK_COMPLETE = type('[OrderAdmin] Order Mark Complete');
    static readonly ORDER_MARK_COMPLETE_SUCCESS = type('[OrderAdmin] Order Mark Complete Success');
    static readonly ORDER_MARK_COMPLETE_FAILURE = type('[OrderAdmin] Order Mark Complete Failure');

    static readonly ORDER_RESUBMIT = type('[OrderAdmin] Order Resubmit');
    static readonly ORDER_RESUBMIT_SUCCESS = type('[OrderAdmin] Order Resubmit Success');
    static readonly ORDER_RESUBMIT_FAILURE = type('[OrderAdmin] Order Resubmit Failure');

    static readonly ORDER_PUSH_UPDATED_FORM = type('[OrderAdmin] Push Updated Form To Order');
    static readonly ORDER_PUSH_UPDATED_FORM_SUCCESS = type(
        '[OrderAdmin] Push Updated Form To Order Success'
    );
    static readonly ORDER_PUSH_UPDATED_FORM_FAILURE = type(
        '[OrderAdmin] Push Updated Form To Order Failure'
    );

    static readonly ORDER_REPLACE_FORM = type('[OrderAdmin] Replace Form PDF On Order');
    static readonly ORDER_REPLACE_FORM_SUCCESS = type(
        '[OrderAdmin] Replace Form PDF On Order Success'
    );
    static readonly ORDER_REPLACE_FORM_FAILURE = type(
        '[OrderAdmin] Replace Form PDF On Order Failure'
    );

    static readonly ORDER_MOVE_BACK_IN_WORKFLOW = type('[OrderAdmin] Order Move Back In Workflow');
    static readonly ORDER_MOVE_BACK_IN_WORKFLOW_SUCCESS = type(
        '[OrderAdmin] Order Move Back In Workflow Success'
    );
    static readonly ORDER_MOVE_BACK_IN_WORKFLOW_FAILURE = type(
        '[OrderAdmin] Order Move Back In Workflow Failure'
    );

    static readonly ORDER_MOVE_FORWARD_IN_WORKFLOW = type(
        '[OrderAdmin] Order Move Forward In Workflow'
    );
    static readonly ORDER_MOVE_FORWARD_IN_WORKFLOW_SUCCESS = type(
        '[OrderAdmin] Order Move Forward In Workflow Success'
    );
    static readonly ORDER_MOVE_FORWARD_IN_WORKFLOW_FAILURE = type(
        '[OrderAdmin] Order Move Forward In Workflow Failure'
    );

    static readonly ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE = type(
        '[OrderAdmin] Order Add BCC Email'
    );
    static readonly ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE_SUCCESS = type(
        '[OrderAdmin] Order Add BCC Email Success'
    );
    static readonly ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE_FAILURE = type(
        '[OrderAdmin] Order Add BCC Email Failure'
    );

    static readonly ORDER_UPDATE_PRODUCT_PROFILE_DATA = type(
        '[OrderAdmin] Order Update Produce Profile Data'
    );
    static readonly ORDER_UPDATE_PRODUCT_PROFILE_DATA_SUCCESS = type(
        '[OrderAdmin] Order Update Produce Profile Data Success'
    );
    static readonly ORDER_UPDATE_PRODUCT_PROFILE_DATA_FAILURE = type(
        '[OrderAdmin] Order Update Produce Profile Data Failure'
    );

    static readonly ORDER_LOAD_IFG_GATEWAY_FILES = type(
        '[OrderAdmin] Order Load IFG Gateway Files'
    );
    static readonly ORDER_LOAD_IFG_GATEWAY_FILES_SUCCESS = type(
        '[OrderAdmin] Order Load IFG Gateway Files Success'
    );
    static readonly ORDER_LOAD_IFG_GATEWAY_FILES_FAILURE = type(
        '[OrderAdmin] Order Load IFG Gateway Files Failure'
    );

    static readonly ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY = type(
        '[OrderAdmin] Order Resubmit File to IFG Gateway'
    );
    static readonly ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY_SUCCESS = type(
        '[OrderAdmin] Order Resubmit File to IFG Gateway Success'
    );
    static readonly ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY_FAILURE = type(
        '[OrderAdmin] Order Resubmit File to IFG Gateway Failure'
    );

    static readonly ORDER_REGENERATE_FILE_LIST = type('[OrderAdmin] Order Regenerate File List');
    static readonly ORDER_REGENERATE_FILE_LIST_SUCCESS = type(
        '[OrderAdmin] Order Regenerate File List Success'
    );
    static readonly ORDER_REGENERATE_FILE_LIST_FAILURE = type(
        '[OrderAdmin] Order Regenerate File List Failure'
    );

    static readonly ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY = type(
        '[OrderAdmin] Order Resubmit Order to IFG Gateway'
    );
    static readonly ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY_SUCCESS = type(
        '[OrderAdmin] Order Resubmit Order to IFG Gateway Success'
    );
    static readonly ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY_FAILURE = type(
        '[OrderAdmin] Order Resubmit Order to IFG Gateway Failure'
    );

    static readonly ORDER_LOAD_QUEUE_OPTIONS = type('[OrderAdmin] Order Load Queue Options');
    static readonly ORDER_LOAD_QUEUE_OPTIONS_SUCCESS = type(
        '[OrderAdmin] Order Load Queue Options Success'
    );
    static readonly ORDER_LOAD_QUEUE_OPTIONS_FAILURE = type(
        '[OrderAdmin] Order Load Queue Options Failure'
    );

    static readonly ORDER_MOVE_QUEUE = type('[OrderAdmin] Order Move Queue');
    static readonly ORDER_MOVE_QUEUE_SUCCESS = type('[OrderAdmin] Order Move Queue Success');
    static readonly ORDER_MOVE_QUEUE_FAILURE = type('[OrderAdmin] Order Move Queue Failure');

    static readonly ORDER_UPDATE_ENVELOPE_RECIPIENTS = type(
        '[OrderAdmin] Order Update Envelope Recipients'
    );
    static readonly ORDER_UPDATE_ENVELOPE_RECIPIENTS_SUCCESS = type(
        '[OrderAdmin] Order Update Envelope Recipients Success'
    );
    static readonly ORDER_UPDATE_ENVELOPE_RECIPIENTS_FAILURE = type(
        '[OrderAdmin] Order Update Envelope Recipients Failure'
    );
}

export type OrderAdminActions =
    | OrderNigoToNeedsClarificationAction
    | OrderNigoToNeedsClarificationSuccessAction
    | OrderNigoToNeedsClarificationFailureAction
    | OrderToWetsignAction
    | OrderToWetsignSuccessAction
    | OrderToWetsignFailureAction
    | AdminMarkOrderCompleteAction
    | AdminMarkOrderCompleteSuccessAction
    | AdminMarkOrderCompleteFailureAction
    | AdminResubmitOrderAction
    | AdminResubmitOrderSuccessAction
    | AdminResubmitOrderFailureAction
    | AdminPushUpdatedFormToOrderAction
    | AdminPushUpdatedFormToOrderSuccessAction
    | AdminPushUpdatedFormToOrderFailureAction
    | AdminReplaceFormOnOrderAction
    | AdminReplaceFormOnOrderSuccessAction
    | AdminReplaceFormOnOrderFailureAction
    | AdminMoveOrderBackInWorkflowAction
    | AdminMoveOrderBackInWorkflowSuccessAction
    | AdminMoveOrderBackInWorkflowFailureAction
    | AdminMoveOrderForwardInWorkflowAction
    | AdminMoveOrderForwardInWorkflowSuccessAction
    | AdminMoveOrderForwardInWorkflowFailureAction
    | AdminAddBlindCarbonCopyToEnvelopeAction
    | AdminAddBlindCarbonCopyToEnvelopeSuccessAction
    | AdminAddBlindCarbonCopyToEnvelopeFailureAction
    | AdminUpdateProductProfileDataAction
    | AdminUpdateProductProfileDataSuccessAction
    | AdminUpdateProductProfileDataFailureAction
    | AdminLoadIfgGatewayFilesAction
    | AdminLoadIfgGatewayFilesSuccessAction
    | AdminLoadIfgGatewayFilesFailureAction
    | AdminResubmitFileToIfgGatewayAction
    | AdminResubmitFileToIfgGatewaySuccessAction
    | AdminResubmitFileToIfgGatewayFailureAction
    | AdminResubmitOrderToIfgGatewayAction
    | AdminResubmitOrderToIfgGatewaySuccessAction
    | AdminResubmitOrderToIfgGatewayFailureAction
    | AdminLoadOrderQueueOptionsAction
    | AdminLoadOrderQueueOptionsSuccessAction
    | AdminLoadOrderQueueOptionsFailureAction
    | AdminMoveOrderQueueAction
    | AdminMoveOrderQueueSuccessAction
    | AdminMoveOrderQueueFailureAction
    | AdminUpdateEnvelopeRecipientsAction
    | AdminUpdateEnvelopeRecipientsSuccessAction
    | AdminUpdateEnvelopeRecipientsFailureAction;

export class OrderNigoToNeedsClarificationAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_NIGO_TO_NEEDS_CLARIFICATION;

    constructor(public payload: OrderMarkNeedsClarificationRequest) {}
}
export class OrderNigoToNeedsClarificationSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_NIGO_TO_NEEDS_CLARIFICATION_SUCCESS;
}
export class OrderNigoToNeedsClarificationFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_NIGO_TO_NEEDS_CLARIFICATION_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class OrderToWetsignAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_TO_WETSIGN;

    constructor(public payload: { orderId: string }) {}
}
export class OrderToWetsignSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_TO_WETSIGN_SUCCESS;
}
export class OrderToWetsignFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_TO_WETSIGN_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminMarkOrderCompleteAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MARK_COMPLETE;

    constructor(public payload: { orderId: string }) {}
}
export class AdminMarkOrderCompleteSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MARK_COMPLETE_SUCCESS;
}
export class AdminMarkOrderCompleteFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MARK_COMPLETE_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminResubmitOrderAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT;

    constructor(public payload: { orderId: string }) {}
}
export class AdminResubmitOrderSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_SUCCESS;
}
export class AdminResubmitOrderFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminPushUpdatedFormToOrderAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_PUSH_UPDATED_FORM;

    constructor(public payload: { orderId: string; formId: string }) {}
}
export class AdminPushUpdatedFormToOrderSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_PUSH_UPDATED_FORM_SUCCESS;
}
export class AdminPushUpdatedFormToOrderFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_PUSH_UPDATED_FORM_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminReplaceFormOnOrderAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_REPLACE_FORM;

    constructor(public payload: { orderId: string; formId: string; file: File }) {}
}
export class AdminReplaceFormOnOrderSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_REPLACE_FORM_SUCCESS;
}
export class AdminReplaceFormOnOrderFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_REPLACE_FORM_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminMoveOrderBackInWorkflowAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_BACK_IN_WORKFLOW;

    constructor(public payload: { orderId: string }) {}
}
export class AdminMoveOrderBackInWorkflowSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_BACK_IN_WORKFLOW_SUCCESS;
}
export class AdminMoveOrderBackInWorkflowFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_BACK_IN_WORKFLOW_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminMoveOrderForwardInWorkflowAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_FORWARD_IN_WORKFLOW;

    constructor(public payload: { orderId: string }) {}
}
export class AdminMoveOrderForwardInWorkflowSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_FORWARD_IN_WORKFLOW_SUCCESS;
}
export class AdminMoveOrderForwardInWorkflowFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_FORWARD_IN_WORKFLOW_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminAddBlindCarbonCopyToEnvelopeAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE;

    constructor(public payload: { orderId: string }) {}
}
export class AdminAddBlindCarbonCopyToEnvelopeSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE_SUCCESS;
}
export class AdminAddBlindCarbonCopyToEnvelopeFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminUpdateProductProfileDataAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_UPDATE_PRODUCT_PROFILE_DATA;

    constructor(public payload: { orderId: string }) {}
}
export class AdminUpdateProductProfileDataSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_UPDATE_PRODUCT_PROFILE_DATA_SUCCESS;
}
export class AdminUpdateProductProfileDataFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_UPDATE_PRODUCT_PROFILE_DATA_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminLoadIfgGatewayFilesAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_LOAD_IFG_GATEWAY_FILES;

    constructor(public payload: { orderId: string }) {}
}
export class AdminLoadIfgGatewayFilesSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_LOAD_IFG_GATEWAY_FILES_SUCCESS;
    constructor(public payload: IfgGatewayIntegrationFile[]) {}
}
export class AdminLoadIfgGatewayFilesFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_LOAD_IFG_GATEWAY_FILES_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminResubmitFileToIfgGatewayAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY;

    constructor(public payload: { orderId: string; fileTransmissionId: string }) {}
}
export class AdminResubmitFileToIfgGatewaySuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY_SUCCESS;

    constructor(public payload: IfgGatewayIntegrationFile[]) {}
}
export class AdminResubmitFileToIfgGatewayFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminRegenerateFileListAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_REGENERATE_FILE_LIST;

    constructor(public payload: { orderId: string }) {}
}
export class AdminRegenerateFileListSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_REGENERATE_FILE_LIST_SUCCESS;

    constructor() {}
}
export class AdminRegenerateFileListFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_REGENERATE_FILE_LIST_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminResubmitOrderToIfgGatewayAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY;

    constructor(
        public payload: {
            orderId: string;
            integrationType: string;
            approvalConfig?: OrderApprovalConfig;
        }
    ) {}
}
export class AdminResubmitOrderToIfgGatewaySuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY_SUCCESS;
}
export class AdminResubmitOrderToIfgGatewayFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminLoadOrderQueueOptionsAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_LOAD_QUEUE_OPTIONS;

    constructor(public payload: { orderId: string }) {}
}
export class AdminLoadOrderQueueOptionsSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_LOAD_QUEUE_OPTIONS_SUCCESS;

    constructor(public payload: OrderQueueOptions) {}
}
export class AdminLoadOrderQueueOptionsFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_LOAD_QUEUE_OPTIONS_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminMoveOrderQueueAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_QUEUE;

    constructor(public payload: { orderId: string; configId: number }) {}
}
export class AdminMoveOrderQueueSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_QUEUE_SUCCESS;
}
export class AdminMoveOrderQueueFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_MOVE_QUEUE_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class AdminUpdateEnvelopeRecipientsAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_UPDATE_ENVELOPE_RECIPIENTS;

    constructor(public payload: { orderId: string; change: OrderRecipientChange }) {}
}
export class AdminUpdateEnvelopeRecipientsSuccessAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_UPDATE_ENVELOPE_RECIPIENTS_SUCCESS;
}
export class AdminUpdateEnvelopeRecipientsFailureAction implements AixAction {
    readonly type = OrderAdminActionTypes.ORDER_UPDATE_ENVELOPE_RECIPIENTS_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}
